import { Component, inject } from '@angular/core';
import { LogisticsActivityParameterService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LogisticsActivityParameterCreateDto,
  LogisticsActivityParameterDto,
  LogisticsActivityParameterExcelDownloadDto,
  LogisticsActivityParameterUpdateDto,
} from '../proxy/controlling/dtos/logistics-activity-parameter';
import { LOGISTICSACTIVITYPARAMETER_CONFIG, LOGISTICSACTIVITYPARAMETER_FIELDS } from './logistics-activity-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-logistics-activity-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LogisticsActivityParameterService, ConfirmationService],
  templateUrl: './logistics-activity-parameter.html',
  styleUrl: './logistics-activity-parameter.scss',
})
export class LogisticsActivityParameter extends BaseHierarchicalCrudComponent<
  LogisticsActivityParameterDto,
  LogisticsActivityParameterCreateDto,
  LogisticsActivityParameterUpdateDto,
  LogisticsActivityParameterExcelDownloadDto
> {
  service = inject(LogisticsActivityParameterService);
  config = LOGISTICSACTIVITYPARAMETER_CONFIG;
  fields = LOGISTICSACTIVITYPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: LogisticsActivityParameterDto): LogisticsActivityParameterUpdateDto {
    return {
      liquidatesWithIva: data.liquidatesWithIva,
      locationTypeId: data.locationTypeId,
      activityProcessParametrizationId: data.activityProcessParametrizationId,
      wbsId: data.wbsId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LogisticsActivityParameter';
  }
}
